<template>
  <div class="tn-error-page">
    <span class="tn-error-page__icon"><v-icon size="40">mdi-shield-lock-outline</v-icon></span>
    <p class="tn-error-page__code">403</p>
    <h2 class="tn-error-page__title">Access denied</h2>
    <p class="tn-error-page__text">Your account doesn't have permission to open this page.</p>
    <v-btn depressed color="primary" exact :to="{ name: 'Home' }">
      <v-icon left size="20">mdi-arrow-left</v-icon> Back to dashboard
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'Unauthorized'
}
</script>
